import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { OrderUserProfileFilter } from '@order/const';
import { ModalComponent, SdvorRadioComponent } from '@sdvor/shared/ui';
import { ModalRef, ModalService } from '@spartacus/storefront';
import { Subscription, take } from 'rxjs';
import { OnlineOrdersListComponentService } from '../../online-orders-list.component-service';

@Component({
  selector: 'sd-online-orders-filter-modal',
  templateUrl: './online-orders-filter-modal.component.html',
  styleUrls: ['./online-orders-filter-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ModalComponent, NgTemplateOutlet, SdvorRadioComponent, ReactiveFormsModule],
})
export class OnlineOrdersFilterModalComponent implements OnInit, OnDestroy {
  orderUserProfileFilter = OrderUserProfileFilter;
  modal: ModalRef;

  orderUserProfileFilterControl = new FormControl();

  private subscription = new Subscription();

  constructor(
    private onlineOrdersListComponentService: OnlineOrdersListComponentService,
    protected modalService: ModalService,
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.onlineOrdersListComponentService
        .getOrderUserProfileFilter()
        .pipe(take(1))
        .subscribe((orderUserProfileFilter) => {
          this.orderUserProfileFilterControl.setValue(orderUserProfileFilter, { emitEvent: false });
        }),
    );

    this.subscription.add(
      this.orderUserProfileFilterControl.valueChanges.subscribe((orderUserProfileFilter: OrderUserProfileFilter) => {
        this.onlineOrdersListComponentService.setOrderUserProfileFilter(orderUserProfileFilter);
        this.modalService.closeActiveModal();
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
